export const contactFilterjson = {
  userid: "",
  qualifies: "",
  teamid: "",
  AffiliatePartner:"",
  educationalstatus: "",
  PageSize: 25,
  PageNo: 1,
  searchtxt: "",
  datefrom: "",
  dateto: "",
  percentagefrom: "",
  percentageto: "",
  intakeyear: "",
  preferredintake: "",
  interestedcountry: "",
  englishtest: "",
  month: "",
  yearofcompletion: "",
  interestedlevelofstudy: "",
  platform: "",
  campaignid: "",
  adsetid: "",
  adid: "",
  profile: "",
  Lead_Source: "",
  Priority: "",
  userid2: "",
  contactrating: "",
  enquiryfor: "",
  interested_country2: "",
  FirstActivitya: "",
  FirstActivityb: "",
  LastActivitya: "",
  LastActivityb: "",
  interestedfieldofstudy: "",
  oshc_type: "",
  previous_visa_refusal: "",
  financial_source: "",
  meeting_interface: "",
  meeting_datea: "",
  meeting_dateb: "",
  branchid: "",
  eventId: "",
  subscribed_leads: "",
  contactCategory: "",
  reasonNotQualify: "",
};

export const GET_TIME_ZONE2 = (time) => {
  var date = new Date(time);

  return (
    date.getDate() +
    " " +
    date.toLocaleString("default", { month: "short" }) +
    " " +
    date.getFullYear() +
    " " +
    date.toLocaleTimeString()
  );
};

export const PartnerContactJson = {
  Contact_Id: "",
  name: "",
  email: "",
  mobile_number: "",
  target_country_code: "",
  amount: "",
  note: "",
};

export const target_country_codeJson = [
  { name: "AFGHANISTAN", code2: "AF", code3: "AFG" },
  { name: "ARGENTINA", code2: "AR", code3: "ARG" },
  { name: "AUSTRALIA", code2: "AU", code3: "AUS" },
  { name: "BANGLADESH", code2: "BD", code3: "BGD" },
  { name: "BRAZIL", code2: "BR", code3: "BRA" },
  { name: "BULGARIA", code2: "BG", code3: "BGR" }, // ✅ Added Bulgaria
  { name: "CAMEROON", code2: "CM", code3: "CMR" },
  { name: "CANADA", code2: "CA", code3: "CAN" },
  { name: "CHILE", code2: "CL", code3: "CHL" },
  { name: "CHINA", code2: "CN", code3: "CHN" },
  { name: "COLOMBIA", code2: "CO", code3: "COL" },
  { name: "CYPRUS", code2: "CY", code3: "CYP" }, // ✅ Added Cyprus
  { name: "DENMARK", code2: "DK", code3: "DNK" }, // ✅ Added Denmark
  { name: "DUBAI", code2: "AE", code3: "ARE" },
  { name: "FIJI", code2: "FJ", code3: "FJI" },
  { name: "FRANCE", code2: "FR", code3: "FRA" },
  { name: "GERMANY", code2: "DE", code3: "DEU" },
  { name: "INDIA", code2: "IN", code3: "IND" },
  { name: "IRAN", code2: "IR", code3: "IRN" },
  { name: "IRELAND", code2: "IE", code3: "IRL" }, // ✅ Added Ireland
  { name: "ITALY", code2: "IT", code3: "ITA" },
  { name: "JAPAN", code2: "JP", code3: "JPN" },
  { name: "KENYA", code2: "KE", code3: "KEN" },
  { name: "LEBANON", code2: "LB", code3: "LBN" },
  { name: "MALAYSIA", code2: "MY", code3: "MYS" }, // ✅ Added Malaysia
  { name: "MALTA", code2: "MT", code3: "MLT" }, // ✅ Added Malta
  { name: "NEPAL", code2: "NP", code3: "NPL" },
  { name: "NETHERLANDS", code2: "NL", code3: "NLD" },
  { name: "NEW ZEALAND", code2: "NZ", code3: "NZL" },
  { name: "NORTHERN IRELAND", code2: "GB", code3: "GBR" },
  { name: "PAKISTAN", code2: "PK", code3: "PAK" },
  { name: "PHILIPPINES", code2: "PH", code3: "PHL" },
  { name: "POLAND", code2: "PL", code3: "POL" }, // ✅ Added Poland
  { name: "SINGAPORE", code2: "SG", code3: "SGP" }, // ✅ Added Singapore
  { name: "SLOVAKIA", code2: "SK", code3: "SVK" },
  { name: "SOUTH AFRICA", code2: "ZA", code3: "ZAF" },
  { name: "SPAIN", code2: "ES", code3: "ESP" },
  { name: "SRI LANKA", code2: "LK", code3: "LKA" },
  { name: "SWITZERLAND", code2: "CH", code3: "CHE" },
  { name: "THAILAND", code2: "TH", code3: "THA" },
  { name: "UNITED KINGDOM", code2: "GB", code3: "GBR" },
  { name: "UNITED STATES", code2: "US", code3: "USA" },
  { name: "VIETNAM", code2: "VN", code3: "VNM" },
];
